import React from 'react';
import { withStyles } from '@material-ui/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import './styles/MiniPalette.css';

const styles = {
  root: {
    backgroundColor: 'white',
    borderRadius: '5px',
    padding: '0.5rem',
    position: 'relative',
    overflow: 'hidden',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  colors: {
    backgroundColor: 'white',
    height: '150px',
    width: '100%'
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0',
    color: 'black',
    paddingTop: '0.5rem',
    fontSize: '1rem',
    position: 'relative'
  },
  emoji: {
    marginLeft: '0.5rem',
    fontSize: '1.5rem'
  },
  miniColor: {
    height: '25%',
    width: '20%',
    display: 'inline-block',
    margin: '0 auto',
    position: 'relative',
    marginBottom: '-3.5px'
  }
};

const MiniPalette = ({ classes, removePalette, ...palette }) => {
  return (
    <div className="MiniPalette">
      <div className={classes.root} onClick={palette.goToPalette}>
        <DeleteIcon className="delete-icon" onClick={removePalette} />
        <div className={classes.colors}>
          {palette.colors.map(color => (
            <div
              className={classes.miniColor}
              style={{ backgroundColor: color.color }}
              key={color.name}
            ></div>
          ))}
        </div>
        <h5 className={classes.title}>
          {palette.paletteName}
          <span className={classes.emoji}>{palette.emoji}</span>
        </h5>
      </div>
    </div>
  );
};

export default withStyles(styles)(MiniPalette);
